import React, { useState, useEffect, useRef } from "react";
import Bubble from "../../../What/components/BubblesGrid/components/Bubble";

const BubbleSelect = ({
  value,
  onChange,
  options = [2, 3, 4, 5, 6],
  title = "Number of People",
  bubbleClassName = "rounded-sm md:rounded-full",
}) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  const handleSelect = (selectedValue) => {
    onChange(selectedValue);
    setShowDropdown(false);
  };

  useEffect(() => {
    if (showDropdown) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [showDropdown]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    if (showDropdown) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showDropdown]);

  return (
    <div ref={dropdownRef} className="relative">
      <div>
        {title ? <h2 className="mb-8">{title}</h2> : null}
        <div className="w-full pb-[100%] relative">
          <div className="w-full h-full absolute top-0 left-0">
            <Bubble
              isSelected={value !== null && value !== undefined}
              onClick={() => setShowDropdown(!showDropdown)}
              shouldAnimate={true}
              cellNo={0}
              className={bubbleClassName + " !rounded-full"}
            >
              <div className="flex flex-col items-center justify-center h-full">
                {value !== null && value !== undefined ? (
                  <>
                    <h4 className="text-4xl md:text-[3vw] p-2">{value}</h4>
                    <span
                      className="text-sm md:text-sm underline text-bold text-[#FFF] cursor-pointer lowercase mt-1"
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowDropdown(!showDropdown);
                      }}
                      style={{
                        textDecoration: "underline",
                        opacity: 0.9,
                      }}
                    >
                      Change
                    </span>
                  </>
                ) : (
                  <h4 className="md:text-[1.5vw] p-4">Select...</h4>
                )}
              </div>
            </Bubble>
          </div>
          {showDropdown && (
            <div className="fixed w-full h-[100vh] top-0 left-0 flex justify-center items-center z-[1000] bg-black bg-opacity-50">
              <div
                className="w-full h-full absolute top-0 left-0"
                onClick={() => setShowDropdown(false)}
              ></div>
              <div
                className=" top-full left-1/2 transform -translate-x-1/2 mt-2 bg-white rounded-lg shadow-xl border border-gray-200 z-50 min-w-[120px]"
                style={{
                  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
                }}
              >
                <div className="py-2">
                  <div>
                    <h4 className="px-4 py-1">Number of People</h4>
                  </div>
                  {options.map((option) => (
                    <div
                      key={option}
                      onClick={() => handleSelect(option)}
                      className={`px-4 py-3 cursor-pointer lowercase text-center transition-colors ${
                        value === option
                          ? "bg-[var(--peachy-pink)] text-white font-bold"
                          : "text-black hover:bg-gray-100"
                      }`}
                      style={{
                        borderBottom:
                          option !== options[options.length - 1]
                            ? "1px solid #f0f0f0"
                            : "none",
                      }}
                    >
                      {option}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BubbleSelect;
